import { render, staticRenderFns } from "./ColorWheel.vue?vue&type=template&id=2e8890be&scoped=true&"
import script from "./ColorWheel.vue?vue&type=script&lang=js&"
export * from "./ColorWheel.vue?vue&type=script&lang=js&"
import style0 from "./ColorWheel.vue?vue&type=style&index=0&id=2e8890be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8890be",
  null
  
)

export default component.exports